// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Feedback widget ---
   A floating tab pinned to the right edge that opens the feedback popup. The popup itself
   reuses the shared modal shell (.modal-overlay/.login-modal); only feedback-specific bits
   live here. */
.feedback-fab {
  position: fixed;
  right: 0;
  top: 75%;
  transform: translateY(-50%);
  transform-origin: right center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  padding: 0;
  background: #4a9eff;
  color: #fff;
  border: none;
  border-radius: 50% 0 0 50%;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  font-family: inherit;
  z-index: 1090;
  transition: background 0.2s;
}

.feedback-fab:hover {
  background: #5aabff;
}

.feedback-fab:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.feedback-fab .icon {
  width: 2rem;
  height: 2rem;
  transform: scaleX(-1);
}

.feedback-modal__subtitle {
  margin: -0.2rem 0 0.2rem;
  font-size: 0.82rem;
  color: #9aa4bf;
}

.feedback-modal textarea {
  padding: 0.55rem 0.6rem;
  background: #12202f;
  color: #fff;
  border: 1px solid #34506e;
  border-radius: 6px;
  font-size: 0.95rem;
  font-family: inherit;
  resize: vertical;
  min-height: 5rem;
}

.feedback-modal textarea:focus {
  outline: none;
  border-color: #4a9eff;
}

.feedback-modal__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  text-align: center;
  color: #cdd8e6;
}

.feedback-modal__success .icon {
  font-size: 2rem;
  color: #4a9eff;
}

.feedback-modal__success p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/feedback-widget/feedback-widget.css"],"names":[],"mappings":"AAAA;;;eAGe;AACf;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,yCAAyC;EACzC,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/* --- Feedback widget ---\r\n   A floating tab pinned to the right edge that opens the feedback popup. The popup itself\r\n   reuses the shared modal shell (.modal-overlay/.login-modal); only feedback-specific bits\r\n   live here. */\r\n.feedback-fab {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 75%;\r\n  transform: translateY(-50%);\r\n  transform-origin: right center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 3rem;\r\n  height: 3rem;\r\n  padding: 0;\r\n  background: #4a9eff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 50% 0 0 50%;\r\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.4);\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  z-index: 1090;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.feedback-fab:hover {\r\n  background: #5aabff;\r\n}\r\n\r\n.feedback-fab:focus-visible {\r\n  outline: 2px solid #fff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.feedback-fab .icon {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  transform: scaleX(-1);\r\n}\r\n\r\n.feedback-modal__subtitle {\r\n  margin: -0.2rem 0 0.2rem;\r\n  font-size: 0.82rem;\r\n  color: #9aa4bf;\r\n}\r\n\r\n.feedback-modal textarea {\r\n  padding: 0.55rem 0.6rem;\r\n  background: #12202f;\r\n  color: #fff;\r\n  border: 1px solid #34506e;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  min-height: 5rem;\r\n}\r\n\r\n.feedback-modal textarea:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.feedback-modal__success {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  text-align: center;\r\n  color: #cdd8e6;\r\n}\r\n\r\n.feedback-modal__success .icon {\r\n  font-size: 2rem;\r\n  color: #4a9eff;\r\n}\r\n\r\n.feedback-modal__success p {\r\n  margin: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
